import "@hotwired/turbo-rails"
import "bootstrap"
import "ahoy.js";

import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'
import TurboStreamController from "../controllers/turbo_stream_controller"

/*********************************
 * Stimulus
 *********************************/

const application = Application.start()
application.debug = process.env.NODE_ENV === 'development'
application.dewey = {}

const controllers = import.meta.glob('./../controllers/chat/**/*.js', { eager: true })
registerControllers(application, controllers)

application.register("turbo-stream", TurboStreamController)